import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 288px;
  height: 524px;
  border-radius: 16px;
  padding: 16px;
  gap: 16px;
  background-color: #ffffff;
  align-self: flex-start;
  row-gap: 16px;
`;

export const Section = styled.div<{ margin?: string; padding?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${({ margin }) => margin || "0"};
  padding: ${({ padding }) => padding || "0"};
`;

export const Text = styled.p<{ fontSize?: string; fontWeight?: string; color?: string }>`
  font-family: Gilroy;
  font-size: ${({ fontSize }) => fontSize || "12px"};
  font-weight: ${({ fontWeight }) => fontWeight || "400"};
  color: ${({ color }) => color || "#1F2D3D"};
`;

export const MediaContainer = styled.div`
  width: auto;
  background-color: #ece7e7;
  border-radius: 16px;
  height: 159px;

  .media-player iframe {
    width: 100%;
    height: 159px;
    border-radius: 16px;
  }
`;

export const CardBody = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #f0f2f9;
  background-color: #fff;

  @media only screen and (max-height: 667px) {
    margin: 8px 0;
    gap: 8px;
  }
`;

export const CardButton = styled.button`
  width: 100%;
  border: 1px solid #1f2d3d;
  border-radius: 40px;
  padding: 12px 16px;
  background-color: white;
  font-size: 16px;
  font-weight: bold;
  color: #1f2d3d;

  @media only screen and (max-height: 667px) {
    padding: 8px 12px;
  }
`;
